import React from 'react';
import request from 'superagent';
import config from '../../../../config';
import { Animated } from "react-animated-css";

class Card extends React.Component {
    state = {
        editing: false
    }
    toggleEditing = () => this.setState({ editing: !this.state.editing });
    save = () => {
        // TODO: call api to save`
        const { contact } = this.props;
        contact.EmailList = this.txtEmail.value;
        request.patch(`${config.apiEndpoint}/api/cs/v2/contact/${contact.id}`)
            .set('Authorization', `Bearer ${config.apiKey}`)
            .send(contact)
            .then((data) => {
                // TODO: Handle any kind of error here
                if (!data.body.success) {
                    alert('ERROR')
                    console.log(data.body);
                    this.setState({ microTransac: false });
                }
            });
        this.setState({ editing: false });
    }
    render() {
        const { index, contact } = this.props, { editing } = this.state;
        return (
            <Animated animationIn="fadeInRight" animationInDelay={50 * index}>
                <figure className="card p-4 margin-right d-flex flex-column justify-content-center pointer hover-red" onClick={() => editing ? null : this.toggleEditing()}>
                    <span className="align-self-center font-18 text-center line1 margin-top-half anton toUpper black ">{contact.Category}</span>
                    {editing && <section>
                        <div className="w-100">
                            <label htmlFor="name" className="block">Email Listing</label>
                            <input className="block w-100" type="text" required ref={(i) => this.txtEmail = i} defaultValue={contact.EmailList} />
                            <span className="blue font-8">(*) Write down emails separated by comma (,)</span>
                        </div>
                        <div className="d-flex flex-row margin-top">
                            <button onClick={this.save} type="submit" style={{ width: 100 }} className="align-self-center btn-white text-center ml-auto">SAVE</button>
                        </div>
                    </section>}
                </figure>
            </Animated>
        )
    }
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/private/contact/partials/card.js